module.exports = __webpack_public_path__ + "img/wb.d049299a.png";